export const classificationRegressionTextColors : { [key: string]: { color: string; backgroundColor: string } } = {
    BE_MEDML_MODELTYPE_CLASSIFICATION: { color: '#fff', backgroundColor: '#1976d2' },
    BE_MEDML_MODELTYPE_CLASSIFICATION_RECOMMENDED: { color: '#fff', backgroundColor: '#1976d2' },
    BE_MEDML_MODELTYPE_REGRESSION: { color: '#fff', backgroundColor: '#388e3c' },
    BE_MEDML_MODELTYPE_REGRESSION_RECOMMENDED: { color: '#fff', backgroundColor: '#388e3c' },
    BE_MEDML_MODELTYPE_DEFAULT: { color: '#fff', backgroundColor: '#f57c00' },
}